import { render, staticRenderFns } from "./MiddlewareSwitchingPortal.vue?vue&type=template&id=148f0434&"
import script from "./MiddlewareSwitchingPortal.vue?vue&type=script&lang=js&"
export * from "./MiddlewareSwitchingPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports